// based on rc-cascader 0.17.4
import Cascader from './Cascader';
export default Cascader;


//////////////////
// WEBPACK FOOTER
// ./~/ant-design-vue/es/vc-cascader/index.js
// module id = 788
// module chunks = 0